<template>
<div class="lesson-region">
  <div class="heading-common is-btn-back">
    <a class="btn-back" @click="goBack">
    <div class="arrow-back"></div>
    </a> 
    <template  v-if="sectionData.title_ruby == '　'"><p class="name" style="vertical-align: middle;">{{ sectionData.title }}</p></template><template v-else><p class="name"><ruby>{{ sectionData.title }}<rt>{{ sectionData.title_ruby }}</rt></ruby></p></template>
  </div>
  <div style="position: relative"
  :class="['lesson-list', 'bg', (classOpened ? 'bg-'+classRegion : '')]"
  v-show="lessonList.length">

    <div v-for="(row, lesson_idx) in lessonList"
    :class="['lesson',
    (classExam(row) ? 'exam' : ''),
    ((classExam(row) && classOpened) ? 'exam-bg-'+classRegion : ''),
    row.lesson_number ? 'lesson-' + row.lesson_number :'',
    classLocked(row) && !classExam(row) ? 'lesson-locked' : '',
    classCompleted(row) ? 'lesson-completed' : '',
    classExamLock(row) ? 'lesson-locked' : ''
    ]"
    @click.prevent="selectLessonItem(row)">
        <div v-if="!classExam(row)" class="number">
           <p>{{ row.lesson_number }}.</p>
        </div>

        <div class="grammar-access">
          <div class="grammar">
              <template v-if="row"><p v-html="row.sub_title"></p></template><template v-else><p></p></template>
          </div>
          <div class="status"
            :class="[
            classCompleted(row) ? 'completed' : '',
            classLocked(row) && !classExam(row) ? 'locked locked-lesson' : '',
            classExamLock(row) ? 'locked locked-exam' : ''
            ]">
          </div>
           <div class="lesson-link"></div>
        </div>
    </div>

  </div>
</div>
</template>

<script>
  import {api, appEnv, useCoachmark} from "../../config";
  import {mapState} from 'vuex';
  import status from '../../mixins/status';


import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';


  export default {
    mixins: [
      status
    ],
    // components: {
    //   'lessonmodal': LessonModal
    // },
    props: {
      region: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        step: 'region',
        authUser: null,
        driver: null,
        storage: {}
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      sectionData() {
        return this.$store.getters.section_data;
      },
      lessonList() {
         return this.$store.getters.lessons
      },
      classRegion() {
        return this.$store.getters.section_data.sort
      },
      classExam: function() {
        return function(item) {
          return (item.lesson_type == 'exam')
        }
      },
      classCompleted: function() {
        return function(item) {
          return (item.status == 'completed')
        }
      },
      classLocked: function() {
        return function(item) {
          if(this.$store.getters.section_data.level != "N4" && this.$store.getters.section_data.level != "N5") {
            return false
          } else {
            return item.lesson_type != "exam"  && (item.status == 'incomplete' || item.section_status == "0")
          }
        }
      },
      classExamLock: function() {
        return function(item) {
          if(this.$store.getters.section_data.level == "N4" || this.$store.getters.section_data.level == "N5") {
            return (item.lesson_type == 'exam' && item.section_status == "0")
          } else {
            const lessonIncomplete = this.$store.getters.lessons.filter(item => {
                return item.lesson_type == "lesson" && item.status != "completed"
            })
            
            return (item.lesson_type == 'exam' && lessonIncomplete.length > 0)
          }
        }
      },
      classOpened: function() {
        return (this.$store.getters.section_data.status !== 'incomplete')
      },
    },

    created() {
      const self = this
      
      self.authUser = self.$store.getters.getAuthUser;

      if(this.driver) {
        this.driver.reset();
      } else {
        this.initCoachMark();
      }
      
      self.$store.dispatch('showLoading', true)
      
      axios.get(api.lessons, {
        params: {
          section_id: self.$store.getters.section_data.section_id,
          section_status: self.$store.getters.section_status
        }
      })
      .then((resp) => {
        self.$store.dispatch('setLessons',  resp.data)
        self.$store.dispatch('showLoading', false)
        
        // regionのcoach markはここで呼ぶ
        if(useCoachmark) {
          self.storage = (appEnv === 'production') ? window.localStorage : window.sessionStorage
        
          const isCoachmarkDone = self.storage.getItem("coachmarkdone") ? JSON.parse(self.storage.getItem("coachmarkdone")) : null;
          if(!(isCoachmarkDone && self.step in isCoachmarkDone && isCoachmarkDone[self.step])) {
            self.showCoachMark();
          }
        }
      
      })
      .catch(err => {
        self.$store.dispatch("showLoading", false);
      });
    },

    mounted() {
    },
    methods: {
      selectLessonItem(row) {
        
        // Locked lessons cannot be viewed
        if(this.$store.getters.section_data.level == "N4" || this.$store.getters.section_data.level == "N5") {
          if ((row.lesson_type != "exam" && (row.status == 'incomplete' || row.section_status == "0")) || (row.lesson_type == "exam" && row.section_status == "0")) {
            return false;
          }
        } else {
          const lessonIncomplete = this.$store.getters.lessons.filter(item => {
              return item.lesson_type == "lesson" && item.status != "completed"
          })
          if (row.lesson_type == "exam" && lessonIncomplete.length > 0) {
            return false;
          }
        }

        if(this.driver) {
          this.driver.reset();
        }

        this.$store.dispatch('showLoading', true);
        this.$store.dispatch('setLessonData', row);
        this.$store.dispatch("setLessonStatus", row.status);

        // Update status the first time
        if (this.$store.getters.lesson_status == 'ready') {
          this.statusLesson('start');
        }

        // Get the contents of a Session or Exam
        let lessonData = this.$store.getters.lesson_data
        axios.get(api.contents, {
          params: {
            section_id: this.$store.getters.section_data.section_id,
            lesson_id: this.$store.getters.lesson_data.lesson_id,
            lesson_type: this.$store.getters.lesson_data.lesson_type
          }
        })
        .then((resp) => {
          this.$store.dispatch('setLessonContent',  resp.data)
          this.$store.dispatch('showLoading', false)

          let push_val = {name: 'lesson.introduction', params: { lesson_id: lessonData.lesson_id }}
          if (lessonData.lesson_type == 'exam') {
            push_val = {name: 'lesson.explanation', params: { lesson_id: lessonData.lesson_id, step: 'exam' }}
          }
          this.$router.push(push_val)
        })
        .catch(err => {
          this.$store.dispatch("showLoading", false);
        });
      },
      initCoachMark() {
        if(this.driver) {
          this.driver.reset()
        } else {
          const driverOverlay = document.getElementById('driver-page-overlay')
          const driverStage = document.getElementById('driver-highlighted-element-stage')
          const driverItem = document.getElementById('driver-popover-item')
          const driverItem2 = document.getElementById('driver-popover-item2')
          
          if(driverOverlay) {
            driverOverlay.remove()
          }
          if(driverStage) {
            driverStage.remove()
          }
          if(driverItem) {
            driverItem.remove()
          }
        }
      },
      showCoachMark() {
        let self = this
        if(!this.authUser) return false;
        
         this.driver = new Driver({
            className: "scoped-class-dark",
            animate: true,
            opacity: 0.7,
            padding: 10,
            stageBackground: 'rgba(255, 255, 255, 0.5)',
            allowClose: true,
            overlayClickNext: false,
            DoneBtnText: "Done",
            CloseBtnText: "Close",
            NextBtnText: "Next",
            PrevBtnText: "Previous step",
            onReset: (e) => {
            
              let coachMarks = JSON.parse(this.storage.getItem("coachmarkdone")|| null);
              if(!coachMarks) {
                coachMarks = {};
                coachMarks[this.step] = true;
              } else {
                coachMarks[this.step] = true;
              }

              this.storage.setItem("coachmarkdone", JSON.stringify(coachMarks));
            }
        })
        setTimeout(() => {
          this.driver.highlight({
            element: '.lesson-1',
            popover: {
              className: 'popover-class',
              title: 'click to Lesson',
            }
          })
        },300)
      },
      goBack() {
        const currentSection = this.$store.getters.section_data
        if(currentSection && currentSection.level) {
          this.$router.push({ name: 'top.level', params: { level: currentSection.level.toLowerCase() } });
        } else {
          this.$router.push({ name: 'top' });
        }
      }
    }
  }
</script>